import React, {useEffect, useRef, useState} from 'react';
import FullCalendar from '@fullcalendar/react';
import resourceTimelinePlugin from '@fullcalendar/resource-timeline';
import axios from 'axios';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import '../css/index.css';
import {Button, Modal} from "react-bootstrap";
import 'react-confirm-alert/src/react-confirm-alert.css';
import moment from 'moment';
import 'chartjs-plugin-datalabels';
import Stats from "../component/Stats";
import {logout} from "../component/redux/reducers/authReducer";
import {useDispatch, useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import {BarLoader} from "react-spinners";
import CalendarScrollbar from "../component/CalendarScrollbar";
import TotpDisplay from "../component/TotpDisplay";
import io from 'socket.io-client';


const Timeline = () => {
    const apiKey = useSelector((state) => state.auth.token);
    const [events, setEvents] = useState([]);
    const [users, setUsers] = useState([]);
    const [currentView, setCurrentView] = useState('resourceTimelineWeek');
    const [selectedEvent, setSelectedEvent] = useState(null);
    const [modalShow, setModalShow] = useState(false);
    const [loadState, setLoadState] = useState(false);
    const [saveState, setSaveState] = useState(false);
    const [selectedStatus, setSelectedStatus] = useState('');
    const [isEditingDate, setIsEditingDate] = useState(false);
    const [editedDate, setEditedDate] = useState('');
    const [isStats, setIsStats] = useState(false);
    const [textareaStatus, setTextareaStatus] = useState(false);
    const [reason, setReason] = useState("");
    const [error, setError] = useState("");

    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    const dispatch = useDispatch();
    const role = useSelector(state => state.auth.role);
    const isAuthenticated = useSelector(state => state.auth.isAuthenticated)
    const navigate = useNavigate();
    const isPermitted = useSelector(state =>
        state.auth.role === "admin" || state.auth.role === "expert"
    );
    const isMe = useSelector(state =>
        state.auth.role === "admin" && state.auth.user.username === "malek"
    );
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [userTotpSecret, setUserTotpSecret] = useState(null);
    const username = useSelector(state => state.auth.user?.username);
    const dropdownRef = useRef(null);
    const cal = useRef(null);
    const statusColors = {
        'Non confirmé': '#8B4513',
        Confirmé: '#FFC300',
        Absent: '#C0392B',
        Présent: '#28A745',
        Annulé: '#343A40',
        Reprogrammé: '#007BFF',
        'Reprogrammé à rappeler': '#8E44AD',
        Nrp: '#A9A9A9',

    };
    const colorToStatus = {
        '#FFC300': 'Confirmé',
        '#C0392B': 'Absent',
        '#28A745': 'Présent',
        '#343A40': 'Annulé',
        '#8E44AD': 'Reprogrammé à rappeler',
        '#007BFF': 'Reprogrammé',
        '#8B4513': 'Non confirmé',
        '#A9A9A9': 'Nrp',
    };


    useEffect(() => {
        if (!isAuthenticated) return;

        let socket;
        const initializeSocket = () => {
            socket = io(`${process.env.REACT_APP_BACKEND_EVENT_SOCKET}`, {
                auth: {
                    apiKey,
                },
            });


            const updateEvent = (prevEvents, newData, updatedFields) => {
                return prevEvents.map((event) =>
                    event.id === newData.id
                        ? {...event, ...newData, ...updatedFields}
                        : event
                );
            };

            socket.on('event', (data) => {
                const newData = data.data;

                switch (data.type) {
                    case 'update':
                        setEvents((prevEvents) =>
                            updateEvent(prevEvents, newData, {color: statusColors[newData.status] || newData.color})
                        );
                        break;

                    case 'new':
                        setEvents((prevEvents) => {
                            const eventExists = prevEvents.some((event) => event.id === newData.id);
                            if (eventExists) {
                                console.warn('Duplicate event detected, skipping:', newData.id);
                                return prevEvents;
                            }

                            const eventSummary = newData.title.toLowerCase().replace(/\s/g, '');
                            let owner = null;
                            if (eventSummary.includes('rdv1')) owner = newData.Prop1;
                            if (eventSummary.includes('rdv2')) owner = newData.Prop2;
                            if (eventSummary.includes('rdv3')) owner = newData.Prop3;

                            const isRdv1 = eventSummary.includes('rdv1');
                            const buildingSuffix = isRdv1 ? '-tn' : '-fr';

                            const resourceIds = [
                                isRdv1 ? 'all-tn' : 'all-fr',
                                owner ? `${owner}${buildingSuffix}` : null,
                            ].filter(Boolean);

                            return [
                                ...prevEvents,
                                {
                                    ...newData,
                                    resourceIds,
                                    color: statusColors[newData.status] || '#8B4513',
                                    email: newData.Email,
                                    objectId: newData.ObjectID,
                                    codePostal: newData.CodePostal,
                                    prop1: newData.Prop1,
                                    prop2: newData.Prop2,
                                    prop3: newData.Prop3,
                                },
                            ];
                        });
                        break;

                    case 'status':
                        setEvents((prevEvents) =>
                            updateEvent(prevEvents, newData, {
                                status: newData.status,
                                color: statusColors[newData.status] || newData.color,
                            })
                        );
                        break;

                    case 'time':
                        setEvents((prevEvents) =>
                            updateEvent(prevEvents, newData, {
                                start: newData.start,
                                end: newData.end,
                                status: newData.status,
                                color: statusColors[newData.status] || newData.color,
                            })
                        );
                        break;

                    case 'oneshot':
                        setEvents((prevEvents) =>
                            updateEvent(prevEvents, newData, {
                                oneshot: newData.oneshot,
                                oneshoter: newData.oneshoter,
                            })
                        );
                        break;

                    case 'delete':
                        setEvents((prevEvents) =>
                            prevEvents.filter((event) => event.id !== newData.id)
                        );
                        break;

                    default:
                        console.warn('Unknown event type:', data.type);
                        break;
                }
            });

        };

        const fetchDataAndConnect = async () => {
            try {
                await fetchEventsAndUsers();
                initializeSocket();
            } catch (error) {
                console.error('Error initializing events or WebSocket:', error);
            }
        };

        fetchDataAndConnect();

        return () => {
            if (socket) {
                socket.off('connect');
                socket.off('event');
                socket.disconnect();
            }
        };
    }, []);


    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsDropdownOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    // Fetch user's TOTP secret
    useEffect(() => {
        const fetchUserTotpSecret = async () => {
            if (!apiKey || !username) return;

            try {
                const response = await axios.get(
                    `${process.env.REACT_APP_BACKEND_EVENT}/auth/totp-secret`,
                    {
                        headers: {
                            Authorization: `Bearer ${apiKey}`
                        }
                    }
                );
                setUserTotpSecret(response.data.totpSecret);
            } catch (error) {
                console.error('Error fetching TOTP secret:', error);
            }
        };

        fetchUserTotpSecret();
    }, [apiKey, username]);

    const fetchEventsAndUsers = async () => {
        try {
            setLoadState(true);

            const response = await axios.get(
                `${process.env.REACT_APP_BACKEND_EVENT}/hubspot/events`,
                {
                    headers: {
                        Authorization: `Bearer ${apiKey}`,
                    },
                }
            );

            if (response.data) {
                const updatedData = response.data.map((item) => {
                    // Update resourceIds to include building suffix
                    const eventTitle = item.title.toLowerCase().replace(/\s/g, '');
                    const isRdv1 = eventTitle.includes('rdv1');
                    const buildingSuffix = isRdv1 ? '-tn' : '-fr';

                    const updatedResourceIds = item.resourceIds.map((resourceId) => {
                        // Skip all-tn and all-fr
                        if (resourceId === 'all-tn' || resourceId === 'all-fr') {
                            return resourceId;
                        }
                        // Add building suffix to user IDs
                        return `${resourceId}${buildingSuffix}`;
                    });

                    return {
                        ...item,
                        color: statusColors[item.status],
                        resourceIds: updatedResourceIds
                    };
                });

                // Extract unique user-building combinations from events
                const userBuildingSet = new Set();

                updatedData.forEach((event) => {
                    event.resourceIds
                        .filter((resourceId) => resourceId !== 'all-fr' && resourceId !== 'all-tn')
                        .forEach((resourceId) => {
                            userBuildingSet.add(resourceId);
                        });
                });

                // Create user entries for each user-building combination
                const extractedValues = Array.from(userBuildingSet).map((resourceId) => {
                    const building = resourceId.endsWith('-tn') ? 'MesProcédures TN' : 'MesProcédures FR';
                    const userId = resourceId.replace(/-tn$|-fr$/, '');

                    return {
                        id: resourceId,
                        title: userId,
                        building: building,
                    };
                });

                const mappedUsers = [
                    {id: 'all-tn', title: 'All', building: 'MesProcédures TN'},
                    {id: 'all-fr', title: 'All', building: 'MesProcédures FR'},
                    ...extractedValues,
                ];
                setEvents(updatedData);
                setUsers(mappedUsers);
                setLoadState(false);
            } else {
                console.error('No items found in response:', response);
            }
        } catch (error) {
            console.error('Error fetching events:', error);
        }
    };

    const fetchContactDetails = async (input) => {
        try {
            let url;
            if (!isPhoneNumber(input)) {
                url = `${process.env.REACT_APP_BACKEND_EVENT}/hubspot/email/${input}`
            } else url = `${process.env.REACT_APP_BACKEND_EVENT}/hubspot/phone/${input}`
            const response = await axios.get(url,
                {
                    headers: {
                        Authorization: `Bearer ${apiKey}`
                    }
                }
            );
            if (response.data) {

                return response.data.hs_all_contact_vids.value
            } else {
                console.error('No contact found with that input.');
                return null;
            }
        } catch (error) {
            console.error('Error fetching contact details:', error);
            return null;
        }
    };


    const handleLogs = () => {
        setIsDropdownOpen(false);
        navigate('/logs', {replace: true});
    };
    const handleLeadConfig = () => {
        setIsDropdownOpen(false);
        navigate('/lead', {replace: true});
    };
    const handleLogout = async () => {
        try {
            await dispatch(logout());
            navigate('/login', {replace: true});
        } catch (error) {
            console.error('Logout failed:', error);
        }
        setIsDropdownOpen(false);
    };
    const handleDatesSet = (arg) => {
        setCurrentView(arg.view.type);
    };
    const handleEventClick = async (clickInfo) => {
        setSelectedEvent(clickInfo.event);
        setSelectedStatus(colorToStatus[clickInfo.event.backgroundColor])
        if (!clickInfo.event.extendedProps.email)
            await fetchContactDetails(clickInfo.event.extendedProps.phone).then(r => setModalShow(true))
        else setModalShow(true)
        setTextareaStatus(clickInfo.event.extendedProps.status === "Annulé")
        setReason(clickInfo.event.extendedProps.reason)

    };
    const handleCloseModal = () => {
        setModalShow(false);
        setSaveState(false)
        setIsEditingDate(false)
        setError("");

    };
    const handleStatusChange = (status) => {
        setSelectedStatus(status);
        if (status === "Annulé")
            setTextareaStatus(true)
        else
            setTextareaStatus(false)
        setSaveState(true)
    };
    const handleEditDate = () => {
        setIsEditingDate(true); // Enable edit mode
    };
    const handleDateChange = (event) => {
        setEditedDate(event.target.value);
    };

    function isPhoneNumber(input) {
        const phoneRegex = /^(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?$/;
        return phoneRegex.test(input);
    }

    const saveNewStatus = async (e) => {
        if (selectedStatus === "Annulé" && !reason.trim()) {
            setError("Ce champ est requis.");
            e.preventDefault();
        } else {
            let id = selectedEvent.extendedProps.objectId
            if (!id) id = await fetchContactDetails(selectedEvent.email)
            try {


                const properties = [
                    {property: 'status_du_rdv', value: selectedStatus},
                    {property: 'id', value: selectedEvent.id},
                    {property: 'reason', value: reason}
                ];

                handleCloseModal()
                setLoadState(true)
                await axios.patch(`${process.env.REACT_APP_BACKEND_EVENT}/hubspot/status/${id}`, {
                    properties
                }, {
                    headers: {
                        Authorization: `Bearer ${apiKey}`
                    }
                });

                setLoadState(false)

            } catch (error) {
                console.error('Error fetching contact details:', error);
            }
        }

    }
    const saveNewDate = async () => {
        if (editedDate) {
            const startDateTime = new Date(new Date(editedDate))
            const formattedDate = new Date(editedDate).toLocaleString('en-fr', {
                timeZone: 'Europe/Paris',
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                hour12: false
            }).toLocaleString()?.replace('at ', '');

            const oneDayLater = new Date();
            oneDayLater.setDate(oneDayLater.getDate() + 1);


            const formattedDate2 = new Date(selectedEvent.start).toLocaleString('en-fr', {
                timeZone: 'Europe/Paris',
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                hour12: false
            }).toLocaleString()?.replace('at ', '');


            if (parseInt(new Date(selectedEvent.start).getTime() / 1000) !== parseInt(new Date(startDateTime).getTime() / 1000)) {
                let id = selectedEvent.extendedProps.objectId


                if (!id) id = await fetchContactDetails(selectedEvent.email)

                let rdvType;

                if (selectedEvent.title.replace(/\s/g, '').toLowerCase().includes('rdv1')) {
                    rdvType = 'rdv1';
                } else if (selectedEvent.title.replace(/\s/g, '').toLowerCase().includes('rdv2')) {
                    rdvType = 'rdv2';
                } else if (selectedEvent.title.replace(/\s/g, '').toLowerCase().includes('rdv3')) {
                    rdvType = 'rdv3';
                } else {
                    console.log('rdv type is unknown !')
                }

                setIsEditingDate(false)
                try {
                    const response = await axios.patch(`${process.env.REACT_APP_BACKEND_EVENT}/hubspot/contact/${id}`, {
                        properties: [
                            {property: rdvType, value: formattedDate},
                            {property: rdvType + '_', value: moment.utc(editedDate, 'MM-DD-YYYY').valueOf()}
                        ],
                        info: [{
                            title: selectedEvent.title,
                            new: formattedDate,
                            old: formattedDate2
                        }]

                    }, {
                        headers: {
                            'Content-Type': 'application/json',
                            Authorization: `Bearer ${apiKey}`
                        }
                    });


                    if (response.status >= 200 && response.status < 300) {
                        await axios.patch(`${process.env.REACT_APP_BACKEND_EVENT}/hubspot/event/${selectedEvent.id}`,
                            {
                                newStartTime: startDateTime,
                                status: (startDateTime > oneDayLater ? "Reprogrammé" : null)
                            },
                            {
                                headers: {
                                    Authorization: `Bearer ${apiKey}`
                                }
                            });
                    } else {
                        console.error('Update failed with status:', response.status);
                    }
                    setIsEditingDate(false);
                    handleCloseModal();
                } catch (error) {
                    console.error('Error updating date:', error);
                }
            } else {
                console.log('the same !')

                setIsEditingDate(false)
            }

        } else {
            setIsEditingDate(false)
        }

    };
    const handleDelete = async () => {
        try {
            handleCloseModal()
            setLoadState(true)
            await axios.delete(`${process.env.REACT_APP_BACKEND_EVENT}/hubspot/event/${selectedEvent.id}`, {
                headers: {
                    Authorization: `Bearer ${apiKey}`
                }
            });
            setLoadState(false)
        } catch (error) {
            console.error('Error fetching contact details:', error);
        }
    };

    const customEventContent = (eventInfo) => {
        const {event, timeText} = eventInfo;
        const OneShot = event.extendedProps.oneshot

        if (currentView === 'dayGridMonth' && event) {
            return (
                <div className="fc-daygrid-event-harness" style={{
                    marginTop: '0px', cursor: 'pointer',
                    textDecoration: 'none'
                }}>
                    <a className="fc-daygrid-event fc-daygrid-dot-event">
                        {OneShot ? <div className="fc-daygrid-event-dot fc-daygrid-event-dot-animated"></div> :
                            <div className="fc-daygrid-event-dot" style={{borderColor: event.backgroundColor,}}></div>}
                        <div className="fc-event-time"
                             style={OneShot ?
                                 {
                                     background: 'linear-gradient(270deg, #00ff00, #32cd32,  #3cb371,    #2e8b57,   #006400 )',
                                     backgroundSize: '400% 400%',
                                     animation: 'gradient-animation 3s ease infinite',
                                     WebkitBackgroundClip: 'text',
                                     WebkitTextFillColor: 'transparent',
                                     backgroundClip: 'text',
                                     color: 'transparent'
                                 } :
                                 {
                                     color: 'black'
                                 }
                             }>
                            {timeText.split('-')[0]}
                        </div>
                        <div className="fc-event-title"
                             style={OneShot ?
                                 {
                                     background: 'linear-gradient(270deg, #00ff00, #32cd32,  #3cb371,    #2e8b57,   #006400 )',
                                     backgroundSize: '400% 400%',
                                     animation: 'gradient-animation 3s ease infinite',
                                     WebkitBackgroundClip: 'text',
                                     WebkitTextFillColor: 'transparent',
                                     backgroundClip: 'text',
                                     color: 'transparent'
                                 } :
                                 {
                                     color: 'black'
                                 }
                             }>
                            {event.title}
                        </div>
                    </a>
                </div>
            );
        } else if (currentView === 'resourceTimelineWeek' && event) {
            return (
                <div className="fc-event-start fc-event-end fc-event-past" style={{
                    borderColor: 'transparent',
                    backgroundColor: 'transparent',
                    cursor: 'pointer',
                    textDecoration: 'none',
                }}>
                    <div className="fc-event-main">
                        <div className="fc-daygrid-event-harness" style={{marginTop: '0px'}}>
                            <a className="fc-daygrid-event fc-daygrid-dot-event">
                                {OneShot ? <div className="fc-daygrid-event-dot fc-daygrid-event-dot-animated"></div> :
                                    <div className="fc-daygrid-event-dot"
                                         style={{borderColor: event.backgroundColor,}}></div>}

                                <div className="fc-event-time"
                                     style={OneShot ?
                                         {
                                             background: 'linear-gradient(270deg, #00ff00, #32cd32,  #3cb371,    #2e8b57,   #006400 )',
                                             backgroundSize: '400% 400%',
                                             animation: 'gradient-animation 3s ease infinite',
                                             WebkitBackgroundClip: 'text',
                                             WebkitTextFillColor: 'transparent',
                                             backgroundClip: 'text',
                                             color: 'transparent'
                                         } :
                                         {
                                             color: 'black'
                                         }
                                     }>
                                    {timeText.split('-')[0]}
                                </div>

                                <div className="fc-event-title"
                                     style={OneShot ?
                                         {
                                             background: 'linear-gradient(270deg, #00ff00, #32cd32,  #3cb371,    #2e8b57,   #006400 )',
                                             backgroundSize: '400% 400%',
                                             animation: 'gradient-animation 3s ease infinite',
                                             WebkitBackgroundClip: 'text',
                                             WebkitTextFillColor: 'transparent',
                                             backgroundClip: 'text',
                                             color: 'transparent'
                                         } :
                                         {
                                             color: 'black'
                                         }
                                     }>
                                    {event.title}
                                </div>

                            </a>
                        </div>
                    </div>
                </div>


            );
        } else {
            return (
                <div className="fc-event-main" style={{
                    backgroundColor: eventInfo.backgroundColor,
                    padding: '5px',
                    borderRadius: '3px',
                    position: 'relative',
                    cursor: 'pointer',
                    textDecoration: 'none',
                    overflow: 'hidden',

                }}>

                    {OneShot ? <span className="animated-border"></span> : null}
                    <span>{eventInfo.timeText.split('-')[0]}</span>
                    <span>{eventInfo.event.title}</span>

                </div>


            );
        }
    };


    return (
        <div>
            {loadState && (
                <div id="loader">
                    <BarLoader height={4} speedMultiplier={1} width={200}/>
                    {events.length === 0 && <p>Chargement du planning </p>}
                    {events.length > 0 && <p>Changement du status </p>}

                </div>
            )}
            {isStats ? (<Stats events={events} setIsStat={setIsStats} apiKey={apiKey}
                               users={[...new Set(Object.values(users).filter(item => item && item.title).map(item => item.title))]}/>) :
                (<div className="App py-2 overflow-y-hidden">
                    <div className="relative" ref={dropdownRef}>
                        {isDropdownOpen && (
                            <div className="absolute right-0 mt-5 w-80 bg-white border border-gray-300 rounded-lg shadow-xl z-50 overflow-hidden">
                                <TotpDisplay totpSecret={userTotpSecret} username={username} />
                                <ul className="py-2">
                                    {role === 'admin' && (
                                        <>
                                            <li
                                                onClick={handleLogs}
                                                className="px-4 py-3 hover:bg-gray-100 cursor-pointer transition-colors flex items-center space-x-2"
                                            >
                                                <i className="bi bi-clock-history text-gray-600"></i>
                                                <span className="font-medium text-gray-700">Logs</span>
                                            </li>
                                            {isMe && (
                                                <li
                                                    onClick={handleLeadConfig}
                                                    className="px-4 py-3 hover:bg-gray-100 cursor-pointer transition-colors flex items-center space-x-2"
                                                >
                                                    <i className="bi bi-person-bounding-box text-gray-600"></i>
                                                    <span className="font-medium text-gray-700">Lead</span>
                                                </li>
                                            )}
                                        </>
                                    )}
                                    <li
                                        onClick={handleLogout}
                                        className={`px-4 py-3 hover:bg-red-50 cursor-pointer transition-colors flex items-center space-x-2 ${role === 'admin' ? 'border-t border-gray-200' : ''}`}
                                    >
                                        <i className="bi bi-box-arrow-right text-red-500"></i>
                                        <span className="font-medium text-red-500">Logout</span>
                                    </li>
                                </ul>
                            </div>
                        )}
                    </div>

                    <div className="calendar-wrapper">
                        {events.length > 0 && (
                            <div className="calendar-header">
                                <CalendarScrollbar/>
                                <FullCalendar
                                    ref={cal}
                                    plugins={[dayGridPlugin, resourceTimelinePlugin, interactionPlugin]}
                                    scrollTimeReset={false}
                                    stickyFooterScrollbar={true}
                                    stickyHeaderDates={true}
                                    initialView="resourceTimelineDay"
                                    resources={users}
                                    events={events.map((item) => ({
                                        ...item,
                                        resourceIds: item.resourceIds.slice(0, 2)
                                    }))}


                                    locale={"fr"}
                                    height={isMobile ? "100vh" : "auto"}
                                    expandRows={true}
                                    filterResourcesWithEvents={true}
                                    aspectRatio={2}
                                    themeSystem="bootstrap5"
                                    slotMinTime="08:30:00"
                                    slotMaxTime="19:00:00"
                                    resourceAreaWidth={isMobile ? "35%" : "10%"}
                                    selectable={true}
                                    eventTimeFormat={{
                                        hour: '2-digit',
                                        minute: '2-digit',
                                        hour12: false,
                                    }}
                                    customButtons={{
                                        customButton: {
                                            icon: "bi  bi-bar-chart",
                                            click: function () {
                                                setIsStats(true)
                                            }
                                        },
                                        settings: {
                                            icon: "bi bi-gear-wide" ,
                                            click: async function (e) {
                                                setIsDropdownOpen(!isDropdownOpen);
                                            }
                                        }
                                    }}
                                    headerToolbar={{
                                        left: 'prev,next,today,customButton',
                                        center: 'title',
                                        right: 'resourceTimelineDay,resourceTimelineWeek,dayGridMonth,settings', // Include 'settings' button in the right
                                    }}
                                    resourceGroupField="building"
                                    resourceAreaHeaderContent="Users"
                                    views={{
                                        resourceTimelineDay: {
                                            slotDuration: '30:00',
                                            slotLabelInterval: '00:30',
                                            eventTimeFormat: {
                                                hour: 'numeric',
                                                minute: '2-digit',
                                                hour12: false,
                                            },
                                            slotLabelFormat: [
                                                {
                                                    hour: '2-digit',
                                                    minute: '2-digit',
                                                    hour12: false
                                                }
                                            ],
                                            slotMinWidth: 80,
                                            titleFormat: {
                                                weekday: 'short',
                                                day: 'numeric',
                                                month: 'long',
                                            },
                                        },
                                        resourceTimelineWeek: {
                                            slotLabelFormat: [{weekday: 'short', day: 'numeric'}],
                                            slotDuration: {days: 1},
                                            eventTimeFormat: {
                                                hour: 'numeric',
                                                minute: '2-digit',
                                                hour12: false,
                                            },
                                            slotMinWidth: isMobile ? 240 : undefined,
                                            titleFormat: {
                                                month: 'long',
                                                day: 'numeric',
                                            }
                                        },
                                        dayGridMonth: {
                                            dayMaxEvents: true,
                                        }
                                    }}
                                    hiddenDays={[0]}
                                    eventContent={customEventContent}
                                    datesSet={handleDatesSet}
                                    eventClick={handleEventClick}
                                />
                            </div>
                        )}
                    </div>

                    {selectedEvent && <Modal show={modalShow} onHide={handleCloseModal}>
                        <Modal.Header closeButton className="d-flex justify-around">

                            <Modal.Title style={{flex: "auto"}}>{selectedEvent.title}</Modal.Title>
                            {isMe && (
                                <button
                                    className="btn me-3"
                                    onClick={() => handleDelete()}
                                    aria-label="Delete Event"
                                    style={{color: "#c70606"}}
                                >
                                    <i className="bi bi-trash "></i>
                                </button>
                            )}
                        </Modal.Header>
                        <Modal.Body>
                            <a target='_blank'
                               href={selectedEvent.extendedProps.objectId ? `https://app-eu1.hubspot.com/contacts/146139336/record/0-1/${selectedEvent.extendedProps.objectId}` : `https://app-eu1.hubspot.com/contacts/144952030/record/0-1/${selectedEvent.extendedProps.email}`}
                               rel="noreferrer"><strong>Name:</strong> {selectedEvent.title.split('-')[1]}</a>
                            <p>
                                <strong>Email:</strong> {selectedEvent.extendedProps.email ? selectedEvent.extendedProps.email.toLocaleString() : 'N/A'}
                            </p>
                            <p>
                                <strong>Phone:</strong> {selectedEvent.extendedProps.phone ? selectedEvent.extendedProps.phone.toLocaleString() : 'N/A'}
                            </p>
                            <p><strong>Code
                                Postal:</strong> {selectedEvent.extendedProps.codePostal ? selectedEvent.extendedProps.codePostal.toLocaleString() : 'N/A'}
                            </p>
                            <p><strong>Propriétaire du rdv
                                1:</strong> {selectedEvent.extendedProps.prop1}
                            </p>
                            {selectedEvent.extendedProps.prop2 && (
                                <p><strong>Propriétaire du rdv
                                    2:</strong> {selectedEvent.extendedProps.prop2}
                                </p>)}
                            {selectedEvent.extendedProps.prop3 && (
                                <p><strong>Propriétaire du rdv
                                    3:</strong> {selectedEvent.extendedProps.prop3}
                                </p>)}

                            {isEditingDate ? (
                                <div>
                                    <label htmlFor="editDate"><strong>Date du RDV:</strong></label>
                                    <input
                                        className="ml-2 form-control-md border-b-1"
                                        type="datetime-local"
                                        id="editDate"
                                        value={editedDate}
                                        onChange={handleDateChange}
                                    />
                                    <button onClick={saveNewDate}><i
                                        style={{fontSize: '1.4em', color: 'green', marginLeft: '18px'}}
                                        class="bi bi-check-lg"></i></button>
                                </div>
                            ) : (
                                <div>
                                    <p><strong>Date du
                                        RDV:</strong> {selectedEvent.start ? new Date(selectedEvent.start).toLocaleString() : 'N/A'}
                                        <button className='ml-3' onClick={handleEditDate}><i
                                            className='bi bi-pencil'></i>
                                        </button>
                                    </p>

                                </div>
                            )}

                            <div className="radio-buttons-container">
                                <div className="radio-row">
                                    {Object.keys(statusColors).map((status) => (
                                        <div key={status} className="radio-item">
                                            <label className="radio-label">
                                                <input
                                                    type="radio"
                                                    name="status"
                                                    value={status}
                                                    checked={selectedStatus === status}
                                                    onChange={() => handleStatusChange(status)}
                                                    className="radio-input"
                                                    disabled={
                                                        !isPermitted && (status === "Absent" || status === "Présent")
                                                    }
                                                />
                                                <div
                                                    className="radio-circle"
                                                    style={{
                                                        backgroundColor: statusColors[status],
                                                        opacity: !isPermitted && (status === "Absent" || status === "Présent") ? 0.5 : 1,
                                                    }}
                                                >
                                                    {selectedStatus === status && (
                                                        <div className="tick-mark">&#10003;</div>
                                                    )}
                                                </div>
                                                <span className="radio-label-text">{status}</span>
                                            </label>
                                        </div>
                                    ))}
                                </div>
                            </div>
                            {textareaStatus && (
                                <div>
                                    <textarea
                                        className="form-control w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-black focus:border-black resize-none"
                                        rows="4"
                                        placeholder={"Veuillez indiquer la raison de l'annulation du rendez-vous..."}
                                        value={reason}
                                        onChange={(e) => {
                                            setReason(e.target.value);
                                            setSaveState(true)
                                        }}
                                        required={true}
                                    />
                                    {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
                                </div>
                            )}
                        </Modal.Body>
                        {saveState && (
                            <Modal.Footer>
                                <Button variant="success" onClick={saveNewStatus}>
                                    Save
                                </Button>

                            </Modal.Footer>
                        )}
                    </Modal>}
                </div>)}


        </div>
    );
};

export default Timeline;
